import Marquee from "react-fast-marquee";
import { useLang } from "@/i18n";

export default function BrandMarquee() {
  const { t } = useLang();
  return (
    <div className="relative bg-ferrari grain text-white py-5 border-y border-ink/80 overflow-hidden mt-[15px]">
      <Marquee speed={55} gradient={false} autoFill>
        {t.marquee.map((item) => (
          <div key={item} className="flex items-center">
            <span className="font-display font-bold uppercase tracking-tight text-xl md:text-3xl px-8">{item}</span>
            <span className="text-2xl md:text-3xl">✦</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
}
